<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم اطلاعات  کارشناس کالیبراسیون '{{innerPersonRecord.fullname}}'</h5>
      <form [formGroup]="EditExpertCalibration" (submit)="SubmitAddNewExpertCalibration()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">محل فعالیت  </label>
            <select formControlName="Area_Type" class="custom-select">
              <option value="0">انتخاب کنید</option>
              <option value="1">داخل آزمایشگاه</option>
              <option value="2">خارج آزمایشگاه</option>
              <option value="3">داخل/خارج آزمایشگاه</option>
            </select>
          </div>
          <div class="form-group col-md-4" style="visibility: hidden;">
            <label for="exampleInputEmail1">مسئولیت</label>
            <input formControlName="Response" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Response().valid && get_Form_Response().touched" class="form-text text-muted MyErrorRedColor">مسئولیت را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-4" style="visibility: hidden;">
            <label for="exampleInputEmail1">توضیحات</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>
        </div>

          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!EditExpertCalibration.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
          <button (click)="OnSet_Expert_Calibration()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>

